<template>
  <div>
    <div class="profile-title-wrap flex">
      <div>
        <a
          class="go-back-wrap"
          href="javascript:;"
          @click="switchTreeOrProfile"
        >
          <i class="el-icon-arrow-left"></i>
          <span :class="viewTime">返回家谱</span>
        </a>
      </div>
      <div class="title-text">查看亲人资料</div>
      <div class="profile-dropdown-wrap">
        <el-dropdown
          placement="bottom"
          trigger="click"
          @command="handleAcation"
        >
          <span class="arrow-down-wrapper">
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="editBtn" :command="1"
              >编辑</el-dropdown-item
            >
            <el-dropdown-item v-if="unbindBtn" :command="2"
              >断连</el-dropdown-item
            >
            <el-dropdown-item v-if="removeBtn" :command="3"
              >删除</el-dropdown-item
            >
            <el-dropdown-item :command="5">导出资料</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div
      class="relative-profile-wrap"
      id="relativeProfile"
      v-loading="profileShade"
    >
      <el-form
        :model="userProfileForm"
        :rules="rules"
        :disabled="editForbit"
        ref="userProfileForm"
        label-width="100px"
        class="user-profile-form"
      >
        <el-form-item
          label="世序"
          class="profile-form-item"
          :class="initFamilyIndex"
        >
          <div class="profile-item-content">
            <span class="content-text">第 {{ nodeInfo.dataGene }} 代</span>
          </div>
        </el-form-item>
        <el-form-item prop="thumbHeadImg" :class="initAvarWrap">
          <div class="head-image-container">
            <img
              class="user-profile-avatar"
              @click="handlePreview"
              src="../../../assets/image/cl_user_avatar.png"
              v-real-img="initUserAvatar"
            />
            <p
              v-if="!editForbit"
              class="change-avatar-btn"
              @click="modifyAvatar"
            >
              更换头像
            </p>
          </div>
          <!-- <p class="modify-avatar-wrap" v-if="!editForbit">
            <el-button class="handlian-btn" @click="modifyAvatar"
              >更换头像</el-button
            >
          </p> -->
          <el-input
            type="hidden"
            v-model="userProfileForm.thumbHeadImg"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="姓名"
          prop="name"
          class="profile-form-item name-item"
        >
          <div class="profile-item-content">
            <el-input
              v-model="userProfileForm.name"
              placeholder="输入姓名"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="性别"
          prop="sex"
          class="profile-form-item name-item"
        >
          <div class="profile-item-content">
            <span v-if="nodeInfo.sex == '1'" class="content-text">男</span>
            <span v-else class="content-text">女</span>
          </div>
        </el-form-item>
        <div class="relative-date-container flex">
          <el-form-item
            label="出生日期"
            prop="birthYear"
            class="profile-item-content"
          >
            <el-input
              v-model="userProfileForm.birthYear"
              @change="birthYearChange"
              placeholder="吉年"
            ></el-input>
            <span class="year-text" ref="birthYearText"></span>
          </el-form-item>
          <el-form-item prop="birthMonth" class="profile-item-content">
            <el-select
              class="relative-date-select"
              placeholder="吉月"
              v-model="userProfileForm.birthMonth"
              @change="birthMonthChange"
            >
              <el-option
                v-for="(item, index) in monthArr"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="birthDay" class="profile-item-content">
            <el-select
              class="relative-date-select"
              placeholder="吉日"
              v-model="userProfileForm.birthDay"
              @change="birthDayChange"
            >
              <el-option
                v-for="(item, index) in dayArr"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="birthTime" class="profile-item-content">
            <el-select
              class="relative-date-select"
              v-model="userProfileForm.birthTime"
              placeholder="吉时"
            >
              <el-option
                v-for="(item, index) in timeArr"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="relative-date-container flex">
          <el-form-item
            label="离世日期"
            prop="deathYear"
            class="profile-item-content"
          >
            <el-input
              v-model="userProfileForm.deathYear"
              @change="deathYearChange"
              placeholder="吉年"
            ></el-input>
            <span class="year-text" ref="deathYearText"></span>
          </el-form-item>
          <el-form-item prop="deathMonth" class="profile-item-content">
            <el-select
              class="relative-date-select"
              placeholder="吉月"
              v-model="userProfileForm.deathMonth"
              @change="deathMonthChange"
            >
              <el-option
                v-for="(item, index) in monthArr"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="deathDay" class="profile-item-content">
            <el-select
              class="relative-date-select"
              placeholder="吉日"
              v-model="userProfileForm.deathDay"
              @change="deathDayChange"
            >
              <el-option
                v-for="(item, index) in dayArr"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="deathTime" class="profile-item-content">
            <el-select
              class="relative-date-select"
              v-model="userProfileForm.deathTime"
              placeholder="吉时"
            >
              <el-option
                v-for="(item, index) in timeArr"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="乳名" prop="petName" class="profile-form-item">
          <div class="profile-item-content">
            <el-input v-model="userProfileForm.petName"></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="出生地"
          prop="birthAddress"
          class="profile-form-item"
        >
          <div class="profile-item-content">
            <el-input v-model="userProfileForm.birthAddress"></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="常住地"
          prop="placeAddress"
          class="profile-form-item"
        >
          <div class="profile-item-content">
            <el-input v-model="userProfileForm.placeAddress"></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="个人简介"
          prop="introduction"
          class="profile-form-item"
        >
          <div class="profile-item-content">
            <el-input
              type="textarea"
              v-model="userProfileForm.introduction"
              resize="none"
              maxlength="200"
              show-word-limit
              :autosize="{ minRows: 2 }"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="profile-buttom-wrap">
            <el-button
              v-if="!editForbit"
              type="primary"
              @click="submitForm('userProfileForm')"
              class="handlian-btn"
              >保存</el-button
            >
            <div class="modify-user-wrap">
              <p>修订人：{{ userProfileForm.addName }}</p>
              <p>{{ userProfileForm.addTime }}</p>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-exhibition-area">
      <el-tabs
        v-model="activeTab"
        type="card"
        @tab-click="productTabClick"
        :stretch="true"
      >
        <el-tab-pane label="文章" name="first">
          <div v-show="articleModule.showList">
            <div class="add-btn-wrap" v-if="nodeInfo.treeType == '1'">
              <el-button @click="openHiddenProduct(0)" class="handlian-btn"
                >添加文章</el-button
              >
            </div>
            <div class="product-list-wrap" v-loading="articleModule.load">
              <div
                v-for="(item, index) in articleModule.list"
                :key="index"
                class="list-item"
                @click="viewArticle(item.modelId)"
              >
                <span>{{ item.title }}</span>
                <span>----------</span>
                <span>{{ initCreateTime(item.created_at) }}</span>
              </div>
              <div
                class="without-anything-wrap"
                v-show="articleModule.list.length == 0"
              >
                <img src="../../../assets/icon/cl_without_anything.png" alt />
                <span>暂无文章</span>
              </div>
            </div>
            <div class="pagination-wrapper">
              <el-pagination
                layout="prev, pager, next"
                ref="articlePage"
                hide-on-single-page
                :total="articleModule.count"
                prev-text="上一页"
                next-text="下一页"
                @current-change="curtArticlePageClick"
              ></el-pagination>
              <!-- @prev-click="prevtArticlePageClick"  @next-click="nextArticlePageClick"  -->
            </div>
          </div>
          <div v-show="!articleModule.showList">
            <div>
              <a
                class="go-list-wrap"
                href="javascript:;"
                @click="showArticleList"
              >
                <i class="el-icon-arrow-left"></i>
                <span>返回列表</span>
              </a>
            </div>
            <ArticleDetail :productId="articleModule.currentId" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="相册" name="second">
          <div v-show="albumModule.showList">
            <div class="add-btn-wrap" v-if="nodeInfo.treeType == '1'">
              <el-button @click="openHiddenProduct(1)" class="handlian-btn"
                >添加相册</el-button
              >
            </div>
            <div class="product-list-wrap" v-loading="albumModule.load">
              <div
                v-for="(item, index) in albumModule.list"
                :key="index"
                class="list-item"
                @click="viewAlbum(item.modelId)"
              >
                <span>{{ item.title }}</span>
                <span>----------</span>
                <span>{{ initCreateTime(item.created_at) }}</span>
              </div>
              <div
                class="without-anything-wrap"
                v-show="albumModule.list.length == 0"
              >
                <img src="../../../assets/icon/cl_without_anything.png" alt />
                <span>暂无相册</span>
              </div>
            </div>
            <div class="pagination-wrapper">
              <el-pagination
                layout="prev, pager, next"
                ref="albumPage"
                hide-on-single-page
                :total="albumModule.count"
                prev-text="上一页"
                next-text="下一页"
                @current-change="curtAlbumPageClick"
              ></el-pagination>
              <!--  @prev-click="prevtAlbumPageClick" @next-click="nextAlbumPageClick" -->
            </div>
          </div>
          <div v-show="!albumModule.showList">
            <div>
              <a
                class="go-list-wrap"
                href="javascript:;"
                @click="showAlbumList"
              >
                <i class="el-icon-arrow-left"></i>
                <span>返回列表</span>
              </a>
            </div>
            <AlbumDetail :productId="albumModule.currentId" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="视频" name="third">
          <div v-show="videoModule.showList">
            <div class="add-btn-wrap" v-if="nodeInfo.treeType == '1'">
              <el-button @click="openHiddenProduct(2)" class="handlian-btn"
                >添加视频</el-button
              >
            </div>
            <div class="product-list-wrap" v-loading="videoModule.load">
              <div
                v-for="(item, index) in videoModule.list"
                :key="index"
                class="list-item"
                @click="viewVideo(item.modelId)"
              >
                <span>{{ item.title }}</span>
                <span>----------</span>
                <span>{{ initCreateTime(item.created_at) }}</span>
              </div>
              <div
                class="without-anything-wrap"
                v-show="videoModule.list.length == 0"
              >
                <img src="../../../assets/icon/cl_without_anything.png" alt />
                <span>暂无视频</span>
              </div>
            </div>
            <div class="pagination-wrapper">
              <el-pagination
                layout="prev, pager, next"
                ref="videoPage"
                hide-on-single-page
                :total="videoModule.count"
                prev-text="上一页"
                next-text="下一页"
                @current-change="curtVideoPageClick"
              ></el-pagination>
              <!-- @prev-click="prevtVideoPageClick" @next-click="nextVideoPageClick" -->
            </div>
          </div>
          <div v-show="!videoModule.showList">
            <div>
              <a
                class="go-list-wrap"
                href="javascript:;"
                @click="showVideoList"
              >
                <i class="el-icon-arrow-left"></i>
                <span>返回列表</span>
              </a>
            </div>
            <VideoDetail :productId="videoModule.currentId" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="音频" name="fourth">
          <div v-show="audioModule.showList">
            <div class="add-btn-wrap" v-if="nodeInfo.treeType == '1'">
              <el-button @click="openHiddenProduct(3)" class="handlian-btn"
                >添加音频</el-button
              >
            </div>
            <div class="product-list-wrap" v-loading="audioModule.load">
              <div
                v-for="(item, index) in audioModule.list"
                :key="index"
                class="list-item"
                @click="viewAudio(item.modelId)"
              >
                <span>{{ item.title }}</span>
                <span>----------</span>
                <span>{{ initCreateTime(item.created_at) }}</span>
              </div>
              <div
                class="without-anything-wrap"
                v-show="audioModule.list.length == 0"
              >
                <img src="../../../assets/icon/cl_without_anything.png" alt />
                <span>暂无音频</span>
              </div>
            </div>
            <div class="pagination-wrapper">
              <el-pagination
                layout="prev, pager, next"
                ref="audioPage"
                hide-on-single-page
                :total="audioModule.count"
                prev-text="上一页"
                next-text="下一页"
                @prev-click="prevtAudioPageClick"
                @current-change="curtAudioPageClick"
                @next-click="nextAudioPageClick"
              ></el-pagination>
            </div>
          </div>
          <div v-show="!audioModule.showList">
            <div>
              <a
                class="go-list-wrap"
                href="javascript:;"
                @click="showAudioList"
              >
                <i class="el-icon-arrow-left"></i>
                <span>返回列表</span>
              </a>
            </div>
            <AudioDetail :productId="audioModule.currentId" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="wait-list-wrapper">
      <el-dialog
        :title="currentMenu.title"
        :visible.sync="waitListVisible"
        width="600px"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :before-close="clearSelectForm"
        custom-class="handlian-share-feed"
      >
        <div class="wait-list-wrap">
          <div class="wait-list-container" v-loading="loadProduct">
            <el-form
              :model="selectFeedForm"
              ref="selectFeedForm"
              class="demo-ruleForm"
            >
              <div
                v-for="(item, index) in waitList"
                :key="index"
                class="wait-item"
              >
                <el-radio v-model="selectFeedForm.addId" :label="item.id">{{
                  item.title
                }}</el-radio>
              </div>
            </el-form>
          </div>
          <div class="select-btn-bar">
            <!-- hide-on-single-page -->
            <div class="pagination-wrapper">
              <el-pagination
                layout="prev, pager, next"
                :total="totalPage"
                prev-text="上一页"
                next-text="下一页"
                ref="pagination"
                @current-change="curtListPageClick"
              ></el-pagination>
              <!-- @prev-click="prevtListPageClick" @next-click="nextListPageClick" -->
            </div>
            <div>
              <el-button
                class="handlian-btn"
                type="primary"
                @click="addThisFeed"
                >确定</el-button
              >
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="vue-cropper-wrap">
      <el-dialog
        title="更换头像"
        :before-close="handleClose"
        :visible.sync="imageCropperVisible"
        custom-class="handlian-cropper-container"
        width="645px"
      >
        <ImageCropper ref="imageCropper" @cropDone="cropDone" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../../../utils/apiMap";
import { getDate } from "../../../utils/date";
import ImageCropper from "../image-cropper";
import ArticleDetail from "./article-detail";
import AlbumDetail from "./album-detail";
import AudioDetail from "./audio-detail";
import VideoDetail from "./video-detail";
import qs from "qs";
export default {
  name: "death-node",
  props: {
    nodeInfo: Object,
  },
  components: {
    ImageCropper,
    ArticleDetail,
    AlbumDetail,
    AudioDetail,
    VideoDetail,
  },
  data() {
    var initMonth = [{ text: "吉月", value: "0" }];
    var initDay = [{ text: "吉日", value: "0" }];
    var initTime = [{ text: "吉时", value: "0" }];
    for (let index = 1; index < 13; index++) {
      const element = {
        text: `${index}月`,
        value: index < 10 ? `0${index}` : String(index),
      };
      initMonth.push(element);
    }
    for (let index = 1; index < 32; index++) {
      const element = {
        text: `${index}日`,
        value: index < 10 ? `0${index}` : String(index),
      };
      initDay.push(element);
    }
    for (let index = 1; index < 25; index++) {
      const element = {
        text: `${index}时`,
        value: index < 10 ? `0${index}` : String(index),
      };
      initTime.push(element);
    }
    var validateYear = (rule, value, callback) => {
      var numberRegExp = /^[0-9]{1,4}$/;
      var blankRegExp = /^\S*$/;
      if (value !== "") {
        if (!blankRegExp.test(value)) {
          callback(new Error("年份不允许有空格"));
        } else if (!numberRegExp.test(value)) {
          callback(new Error("年份为1~4位数字"));
        } else if (value.indexOf("0") == 0) {
          callback(new Error("年份首位不能是0"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      profileShade: true,
      imageCropperVisible: false,
      waitListVisible: false,
      waitList: [],
      editForbit: true,
      loadProduct: true,
      activeTab: "first",
      userProfile: {},
      userProfileForm: {
        name: "",
        sex: "",
        birthYear: "",
        birthMonth: "",
        birthDay: "",
        birthTime: "",
        deathYear: "",
        deathMonth: "",
        deathDay: "",
        deathTime: "",
        petName: "",
        birthAddress: "",
        placeAddress: "",
        introduction: "",
        headImgUrl: "",
        thumbHeadImg: "",
        addName: "",
        addTime: "",
      },
      selectFeedForm: {
        addId: "",
      },
      totalPage: 0,
      currentMenu: {
        title: "选择文章",
        mold: 0,
      },
      articleModule: {
        count: 0,
        list: [],
        load: true,
        showList: true,
        currentId: 0,
      },
      albumModule: {
        count: 0,
        list: [],
        load: true,
        showList: true,
        currentId: 0,
      },
      videoModule: {
        count: 0,
        list: [],
        load: true,
        showList: true,
        currentId: 0,
      },
      audioModule: {
        count: 0,
        list: [],
        load: true,
        showList: true,
        currentId: 0,
      },
      monthArr: initMonth,
      dayArr: initDay,
      timeArr: initTime,
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 1,
            max: 40,
            message: "长度在 2 到 40 个字符",
            trigger: "blur",
          },
        ],
        birthYear: [{ validator: validateYear, trigger: "blur" }],
        deathYear: [{ validator: validateYear, trigger: "blur" }],
        petName: [
          { required: false, message: "请输入乳名", trigger: "blur" },
          {
            min: 1,
            max: 25,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        birthAddress: [
          { required: false, message: "请输入出生地", trigger: "blur" },
          {
            min: 1,
            max: 25,
            message: "长度在 1 到 150 个字符",
            trigger: "blur",
          },
        ],
        placeAddress: [
          { required: false, message: "请输入常住地", trigger: "blur" },
          {
            min: 1,
            max: 25,
            message: "长度在 1 到 150 个字符",
            trigger: "blur",
          },
        ],
        introduction: [
          { required: false, message: "请输入个人简介", trigger: "blur" },
          {
            min: 1,
            max: 200,
            message: "长度在 1 到 200 个字符",
            trigger: "blur",
          },
        ],
      },
      newLiveUser: [],
    };
  },
  computed: {
    ...mapGetters(["fatherTreeNote"]),
    viewTime() {
      return this.nodeInfo.clickTime;
    },
    initFamilyIndex() {
      if (this.nodeInfo.treeType == 1 && this.nodeInfo.mate == false) {
        return "entity";
      } else {
        return "virtual";
      }
    },
    initAvarWrap() {
      if (this.nodeInfo.treeType == 1 && this.nodeInfo.mate == false) {
        return "head-image-wrap";
      } else {
        return "head-image-wrapper";
      }
    },
    initUserAvatar() {
      if (this.userProfileForm.thumbHeadImg) {
        return this.userProfileForm.thumbHeadImg;
      } else {
        return "http://148.70.221.198/pc/image/cl_user_avatar.png";
      }
    },
    unbindBtn() {
      if (this.nodeInfo && this.nodeInfo.unbindFlag) {
        return true;
      } else {
        return false;
      }
    },
    // throwUnbindBtn() {
    //   if (this.nodeInfo && this.nodeInfo.dataCopy == "1") {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    removeBtn() {
      if (this.nodeInfo) {
        if (
          this.nodeInfo.hasOwnProperty("removeFlag") &&
          this.nodeInfo.removeFlag != -1
        ) {
          return true;
        }
      } else {
        return false;
      }
    },
    editBtn() {
      if (this.nodeInfo.treeType == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getUserProfile();
  },
  methods: {
    beArray(arr) {
      return arr instanceof Array;
    },
    getUserProfile() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var params = `token=${loginUser.token}&deathUserId=${this.nodeInfo.userId}`;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["deathProfile"]["method"],
          url: apiMap["deathProfile"]["url"],
          data: params,
        })
        .then(function(response) {
          _this.profileShade = false;
          if (response.data.result.statusCode == 1) {
            _this.userProfile = response.data.result.data;
            _this.initUserProfile(response.data.result.data);
            _this.getDeadArticle(1);
          } else {
            var tips = `未查询到 ${this.nodeInfo.name} 的资料`;
            _this
              .$confirm(tips, {
                confirmButtonText: "确定",
                closeOnClickModal: false,
                showClose: false,
                customClass: "cl-edit-profile",
              })
              .then(() => {
                _this.switchTreeOrProfile();
              })
              .catch(() => {});
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initUserProfile(data) {
      this.userProfileForm.name = data.name;
      this.userProfileForm.sex = data.sex;
      this.userProfileForm.petName = data.usedName;
      this.userProfileForm.birthAddress = data.birthAddress;
      this.userProfileForm.placeAddress = data.locationAddress;
      this.userProfileForm.introduction = data.description;
      this.userProfileForm.headImgUrl = data.headImg;
      this.userProfileForm.thumbHeadImg = data.thumbHeadImg;
      this.userProfileForm.addName = data.userInfo.realName;
      this.userProfileForm.addTime = getDate(
        new Date(data.addTime * 1000),
        "."
      );
      var getBirth = data.birthday.toString().split(".");
      var getDeath = data.deathDay.toString().split(".");
      var numberRegExp = /^[0-9]+$/;
      //初始化出生日期
      for (var i = 0; i < getBirth.length; i++) {
        if (numberRegExp.test(getBirth[0]) && getBirth[0] > 0) {
          this.userProfileForm.birthYear = getBirth[0];
          this.$refs.birthYearText.innerText = "年";
          if (numberRegExp.test(getBirth[1])) {
            this.userProfileForm.birthMonth = getBirth[1];
          }
          if (numberRegExp.test(getBirth[2])) {
            this.userProfileForm.birthDay = getBirth[2];
          }
          if (numberRegExp.test(getBirth[3])) {
            this.userProfileForm.birthTime = getBirth[3];
          }
        } else {
          this.$refs.birthYearText.innerText = "";
        }
      }
      //初始化离世日期
      for (var i = 0; i < getDeath.length; i++) {
        if (numberRegExp.test(getDeath[0]) && getDeath[0] > 0) {
          this.userProfileForm.deathYear = getDeath[0];
          this.$refs.deathYearText.innerText = "年";
          if (numberRegExp.test(getDeath[1])) {
            this.userProfileForm.deathMonth = getDeath[1];
          }
          if (numberRegExp.test(getDeath[2])) {
            this.userProfileForm.deathDay = getDeath[2];
          }
          if (numberRegExp.test(getDeath[3])) {
            this.userProfileForm.deathTime = getDeath[3];
          }
        } else {
          this.$refs.deathYearText.innerText = "";
        }
      }
    },
    switchTreeOrProfile() {
      this.clearProfileForm();
      this.$bus.$emit("switch-tree-profile", {});
    },
    birthYearChange(year) {
      if (year === "" || year.trim().length === 0) {
        this.userProfileForm.birthMonth = "";
        this.userProfileForm.birthDay = "";
        this.userProfileForm.birthTime = "";
        this.$refs.birthYearText.innerText = "";
      } else {
        var numberRegExp = /^[0-9]{1,4}$/;
        var blankRegExp = /^\S*$/;
        if (
          blankRegExp.test(year) &&
          numberRegExp.test(year) &&
          year.indexOf("0") != 0
        ) {
          this.$refs.birthYearText.innerText = "年";
        } else {
          this.$refs.birthYearText.innerText = "";
        }
      }
    },
    birthMonthChange(month) {
      if (month == "0") {
        this.userProfileForm.birthDay = "";
        this.userProfileForm.birthTime = "";
      }
    },
    birthDayChange(day) {
      if (day == "0") {
        this.userProfileForm.birthTime = "";
      }
    },
    deathYearChange(year) {
      if (year === "" || year.trim().length === 0) {
        this.userProfileForm.deathMonth = "";
        this.userProfileForm.deathDay = "";
        this.userProfileForm.deathTime = "";
        this.$refs.deathYearText.innerText = "";
      } else {
        var numberRegExp = /^[0-9]{1,4}$/;
        var blankRegExp = /^\S*$/;
        if (
          blankRegExp.test(year) &&
          numberRegExp.test(year) &&
          year.indexOf("0") != 0
        ) {
          this.$refs.deathYearText.innerText = "年";
        } else {
          this.$refs.deathYearText.innerText = "";
        }
      }
    },
    deathMonthChange(month) {
      if (month == "0") {
        this.userProfileForm.deathDay = "";
        this.userProfileForm.deathTime = "";
      }
    },
    deathDayChange(day) {
      if (day == "0") {
        this.userProfileForm.deathTime = "";
      }
    },
    clearProfileForm() {
      this.userProfile = {};
      this.editForbit = true;
      this.profileShade = true;
      this.userProfileForm.sex = null;
      this.userProfileForm.birthYear = "";
      this.$refs.birthYearText.innerText = "";
      this.userProfileForm.birthMonth = "";
      this.userProfileForm.birthDay = "";
      this.userProfileForm.birthTime = "";
      this.userProfileForm.thumbHeadImg = null;
      this.$refs.deathYearText.innerText = "";
      this.userProfileForm.deathYear = "";
      this.userProfileForm.deathMonth = "";
      this.userProfileForm.deathDay = "";
      this.userProfileForm.deathTime = "";
      this.activeTab = "first";
      this.articleModule.list = [];
      this.articleModule.count = 0;
      this.albumModule.list = [];
      this.albumModule.count = 0;
      this.audioModule.list = [];
      this.audioModule.count = 0;
      this.videoModule.list = [];
      this.videoModule.count = 0;
    },
    modifyAvatar() {
      this.imageCropperVisible = true;
    },
    handleClose() {
      this.$refs.imageCropper.resetCropper();
      this.imageCropperVisible = false;
    },
    cropDone(status, url) {
      this.imageCropperVisible = false;
      //状态1为头像上传成功
      if (status == 1) {
        this.userProfileForm.headImgUrl = url;
        this.userProfileForm.thumbHeadImg = url;
      }
    },
    handleAcation(action) {
      //1-编辑资料 2 -断连 3-删除 4-跨代断连
      switch (action) {
        case 1:
          if (this.nodeInfo.treeType == "1") {
            var tips =
              "点击“确定”后，可以编辑和保存亲人资料。\n系统只保存最后一次修改记录，确定要修改吗？";
            this.$confirm(tips, {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              closeOnClickModal: false,
              customClass: "cl-edit-profile",
            })
              .then(() => {
                this.editForbit = false;
              })
              .catch(() => {});
          } else {
            this.$alert("您不能编辑母系家谱成员资料哦", {
              confirmButtonText: "确定",
              showClose: false,
            });
          }
          break;
        case 2:
          this.unbindRelation();
          break;
        case 3:
          this.removeDeadNode();
          break;
        case 4:
          this.throwbackUnbind();
          break;
        case 5:
          this.printProfile();
          break;
      }
    },
    printProfile() {
      this.$message({
        message: "正在导出资料……",
        duration: 1500,
        offset: 230,
        type: "success",
      });
      var fileName = this.userProfileForm.name || "个人资料";
      this.ExportSavePdf(fileName, "#relativeProfile");
    },
    throwbackUnbind() {
      let _this = this;
      if (_this.fatherTreeNote.hasOwnProperty("copyNode")) {
        var copyMark = JSON.parse(_this.fatherTreeNote.copyNode);
        var relativeId = _this.nodeInfo.userId;
        var nodeIdArr = [relativeId];
        for (let i in copyMark) {
          if (copyMark[i].hasOwnProperty("userName")) {
            if (copyMark[i].userId == relativeId) {
              break;
            } else {
              nodeIdArr.push(copyMark[i].userId);
            }
          }
        }
        var relativeName = _this.nodeInfo.name;
        var tipMsg =
          "断连后，你的家谱将只看到包含 “ " +
          relativeName +
          " ” 以下的亲人，确定要断开吗？";

        _this
          .$confirm(tipMsg, {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false,
            customClass: "cl-edit-profile",
            showClose: false,
          })
          .then(() => {
            let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
            var params = {
              token: loginUser.token,
              userId: loginUser.userId,
              relationUserId: _this.nodeInfo.userId,
              copyUserId: nodeIdArr.join(","),
              relationName: "父亲",
              family: "1",
            };
            _this
              .$axios({
                baseURL: apiMap["commonUrl"],
                method: apiMap["unbindRelation"]["method"],
                url: apiMap["unbindRelation"]["url"],
                data: qs.stringify(params, { encode: false }),
              })
              .then(function(response) {
                // console.log(response.data.result.data)
                if (response.data.result.statusCode == 1) {
                  _this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                    offset: 230,
                  });
                  _this.$bus.$emit("reload-father-tree", "1");
                  _this.switchTreeOrProfile();
                } else {
                  _this.$message({
                    message: "操作失败，稍后再试",
                    duration: 1500,
                    offset: 230,
                  });
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          })
          .catch(() => {});
      }
    },
    unbindRelation() {
      let _this = this;
      // console.log(this.nodeInfo.unbindFlag)
      var tipMsg = "断连后，家谱中不再出现此亲人\n确定要断开吗？";
      if (_this.nodeInfo.unbindFlag.hasOwnProperty("relation")) {
        var spouseCut = ["丈夫", "妻子"];
        var afterCut = ["儿子", "女儿"];
        var beforeCut = ["父亲"];
        var relativeName = _this.nodeInfo.name;
        var relativeKey = _this.nodeInfo.unbindFlag.relation;
        // console.log(relativeKey)
        if (spouseCut.includes(relativeKey)) {
          tipMsg =
            "断连后，家谱中不再出现 “ " +
            relativeName +
            " ”，且此操作不可以恢复！确定要断开吗？";
        } else if (afterCut.includes(relativeKey)) {
          //子父断连
          tipMsg =
            "断连后，你的家谱不再出现包含 “ " +
            relativeName +
            " ” 以下的亲人，确定要断开吗？";
        } else if (beforeCut.includes(relativeKey)) {
          //父子断连 （当前登录者离开家谱）
          // if (_this.fatherTreeNote.hasOwnProperty("copyNode")) {
          //   var copyMark = JSON.parse(_this.fatherTreeNote.copyNode);
          //   for (let i in copyMark) {
          //     if (copyMark[i].hasOwnProperty("userName")) {
          //       _this.unbindRelationTip(copyMark[i]);
          //       return false;
          //     }
          //   }
          // }
          tipMsg =
            "断连后，你的家谱不再出现 “ " +
            relativeName +
            " ” 以上的亲人，且不可以恢复，确定要断开吗？";
        }
        _this
          .$confirm(tipMsg, {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false,
            customClass: "tree-member-change",
            showClose: false,
          })
          .then(() => {
            let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
            var params = {
              token: loginUser.token,
              userId: _this.nodeInfo.userId,
              relationUserId: _this.nodeInfo.unbindFlag.userId,
              relationName: relativeKey,
            };
            // 参数注释：
            // userId 与 relationUserId 断绝 relationName 关系
            // 如果不传userId，表示 当前登录用户 与 relationUserId 断绝 relationName 关系
            _this
              .$axios({
                baseURL: apiMap["commonUrl"],
                method: apiMap["unbindRelation"]["method"],
                url: apiMap["unbindRelation"]["url"],
                data: qs.stringify(params, { encode: false }),
              })
              .then(function(response) {
                if (response.data.result.statusCode == 1) {
                  if (relativeKey == "父亲") {
                    _this.getClanTree();
                  }
                  _this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                    offset: 230,
                  });
                  setTimeout(() => {
                    _this.$bus.$emit("reload-father-tree", "1");
                    _this.switchTreeOrProfile();
                  }, 1500);
                } else {
                  _this.$message({
                    message: "操作失败，稍后再试",
                    duration: 1500,
                    offset: 230,
                  });
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          })
          .catch(() => {});
      }
    },
    unbindRelationTip(userInfo) {
      var tipMsg = `请先点击 “ ${userInfo.userName} ” ，进行断连后，再操作当前断连。`;
      this.$confirm(tipMsg, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showClose: false,
      })
        .then(() => {})
        .catch(() => {});
    },
    removeDeadNode() {
      if (this.nodeInfo.treeType == "1") {
        var tips = "删除后，将不可恢复，确定要删除吗？";
        this.$confirm(tips, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
        })
          .then(() => {
            let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
            if (this.userProfile && this.userProfile.userId) {
              if (this.userProfile.userId == loginUser.userId.toString()) {
                this.executeRemove();
              } else {
                this.$alert("只有该节点的创建人才能删除", {
                  confirmButtonText: "确定",
                  showClose: false,
                });
              }
            } else {
              this.executeRemove();
            }
          })
          .catch(() => {});
      } else {
        this.$alert("您不能删除母系家谱成员哦", {
          confirmButtonText: "确定",
          showClose: false,
        });
      }
    },
    executeRemove(deathId, cruxId) {
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let _this = this;
      var submit = {
        token: loginUser.token,
        whoId: _this.nodeInfo.userId,
      };
      if (_this.userProfile.userId == loginUser.userId.toString()) {
        if (_this.nodeInfo.linealNode != "") {
          submit.userId = _this.nodeInfo.linealNode;
        }
      }
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["removeNode"]["method"],
          url: apiMap["removeNode"]["url"],
          data: qs.stringify(submit, { encode: false }),
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              offset: 230,
            });
            _this.$bus.$emit("reload-father-tree", "2");
            _this.switchTreeOrProfile();
          } else {
            _this.$message({
              message: "操作失败，稍后再试",
              duration: 1500,
              offset: 230,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    handlePreview() {
      this.$bus.$emit("avatar-preview", {
        url:
          this.userProfileForm.thumbHeadImg ||
          "http://148.70.221.198/pc/image/cl_user_avatar.png",
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var birthYear = +this.userProfileForm.birthYear;
          var deathYear = +this.userProfileForm.deathYear;
          var diffYear = deathYear - birthYear;
          var curYear = new Date().getFullYear();
          var trueYear = curYear - deathYear;
          if (birthYear > 0 && deathYear > 0 && diffYear < 0) {
            this.$alert("离世年份不能小于出生年份", {
              confirmButtonText: "确定",
              showClose: false,
            });
            return false;
          }
          if (trueYear < 0) {
            this.$alert("离世年份不能大于当前年份", {
              confirmButtonText: "确定",
              showClose: false,
            });
            return false;
          }
          var inputFullBirth = "0";
          var inputFullDeath = "0";
          if (birthYear > 0) {
            var inputBirthYear, inputBirthMonth, inputBirthDay, inputBirthTime;
            inputBirthMonth = this.userProfileForm.birthMonth;
            inputBirthYear =
              inputBirthMonth == "" ? birthYear : `${birthYear}.`;
            inputBirthDay =
              inputBirthMonth == "" ? "" : this.userProfileForm.birthDay;
            inputBirthTime =
              inputBirthDay == "" ? "" : this.userProfileForm.birthTime;
            if (inputBirthDay != "") {
              inputBirthMonth = `${inputBirthMonth}.`;
            }
            if (inputBirthTime != "") {
              inputBirthDay = `${inputBirthDay}.`;
            }
            inputFullBirth =
              inputBirthYear + inputBirthMonth + inputBirthDay + inputBirthTime;
          }
          if (deathYear > 0) {
            var inputDeadYear, inputDeadMonth, inputDeadDay, inputDeadTime;
            inputDeadMonth = this.userProfileForm.deathMonth;
            inputDeadYear = inputDeadMonth == "" ? deathYear : `${deathYear}.`;
            inputDeadDay =
              inputDeadMonth == "" ? "" : this.userProfileForm.deathDay;
            inputDeadTime =
              inputDeadDay == "" ? "" : this.userProfileForm.deathTime;
            if (inputDeadDay != "") {
              inputDeadMonth = `${inputDeadMonth}.`;
            }
            if (inputDeadTime != "") {
              inputDeadDay = `${inputDeadDay}.`;
            }
            inputFullDeath =
              inputDeadYear + inputDeadMonth + inputDeadDay + inputDeadTime;
          }
          var submitData = {
            action: "2",
            deathUserId: this.nodeInfo.userId,
            token: loginUser.token,
            userId: loginUser.userId,
            name: this.userProfileForm.name,
            birthAddress: this.userProfileForm.birthAddress,
            locationAddress: this.userProfileForm.placeAddress,
            usedName: this.userProfileForm.petName,
            description: this.userProfileForm.introduction,
            headImg: this.userProfileForm.headImgUrl,
            thumbHeadImg: this.userProfileForm.thumbHeadImg,
          };
          if (inputFullBirth != "0") {
            submitData.birthday = inputFullBirth;
          }
          if (inputFullBirth != "0") {
            submitData.deathDay = inputFullDeath;
          }
          if (this.nodeInfo.treeType == "1") {
            //只允许修改父系成员资料
            this.updateUserProfile(qs.stringify(submitData, { encode: false }));
          }
        } else {
          return false;
        }
      });
    },
    updateUserProfile(params) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["operateDeathNode"]["method"],
          url: apiMap["operateDeathNode"]["url"],
          data: params,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.$message({
              message: "保存成功",
              type: "success",
              duration: 1500,
              offset: 230,
            });
            _this.editForbit = true;
            _this.$bus.$emit("reload-father-tree", "2");
          } else {
            _this.$message({
              message: "保存失败，稍后再试",
              duration: 1500,
              offset: 230,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    productTabClick(tab) {
      switch (tab.index) {
        case "0":
          this.getDeadArticle(1);
          break;
        case "1":
          this.getDeadAlbum(1);
          break;
        case "2":
          this.getDeadVideo(1);
          break;
        case "3":
          this.getDeadAudio(1);
          break;
      }
    },
    openHiddenProduct(type) {
      this.waitListVisible = true;
      switch (type) {
        case 0:
          this.currentMenu = { title: "选择文章", mold: type };
          this.getArticleList(1);
          break;
        case 1:
          this.currentMenu = { title: "选择相册", mold: type };
          this.getAlbumList(1);
          break;
        case 2:
          this.currentMenu = { title: "选择视频", mold: type };
          this.getVideoList(1);
          break;
        case 3:
          this.currentMenu = { title: "选择音频", mold: type };
          this.getAudioList(1);
          break;
      }
    },
    clearSelectForm() {
      this.waitListVisible = false;
      this.loadProduct = true;
      this.selectFeedForm.addId = "";
    },
    withoutProductTip(type) {
      let tipHandle = { 0: "文章", 1: "相册", 2: "视频", 3: "音频" };
      var tips = `未查询到满足以下条件的${tipHandle[type]}：\n1. 隐藏的${tipHandle[type]}\n2. 没有添加给其他亲人\n请先将你的${tipHandle[type]}永久保存，然后设置为隐藏`;
      this.$confirm(tips, {
        confirmButtonText: "确定",
        closeOnClickModal: false,
        showClose: false,
        customClass: "cl-edit-profile",
      })
        .then(() => {
          this.clearSelectForm();
        })
        .catch(() => {
          this.clearSelectForm();
        });
    },
    initCreateTime(data) {
      return getDate(new Date(data * 1000), ".");
    },
    getArticleList(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["articleList"]["method"],
          url: apiMap["articleList"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            orderField: "created_at",
            order: "desc",
            type: 2,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.waitList = response.data.result.data;
            _this.totalPage = response.data.result.count;
            _this.loadProduct = false;
          } else {
            if (response.data.result.count == 0) {
              _this.withoutProductTip(0);
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getAlbumList(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["albumList"]["method"],
          url: apiMap["albumList"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            orderField: "created_at",
            order: "desc",
            type: 2,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.waitList = response.data.result.data;
            _this.totalPage = response.data.result.count;
            _this.loadProduct = false;
          } else {
            if (response.data.result.count == 0) {
              _this.withoutProductTip(1);
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getVideoList(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["videoList"]["method"],
          url: apiMap["videoList"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            orderField: "created_at",
            order: "desc",
            type: 2,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.waitList = response.data.result.data;
            _this.totalPage = response.data.result.count;
            _this.loadProduct = false;
          } else {
            if (response.data.result.count == 0) {
              _this.withoutProductTip(2);
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getAudioList(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["audioList"]["method"],
          url: apiMap["audioList"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            orderField: "created_at",
            order: "desc",
            type: 2,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.waitList = response.data.result.data;
            _this.totalPage = response.data.result.count;
            _this.loadProduct = false;
          } else {
            if (response.data.result.count == 0) {
              _this.withoutProductTip(3);
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    addThisFeed() {
      let _this = this;
      if (_this.selectFeedForm.addId != "") {
        var typePool = { 0: "1", 1: "2", 2: "4", 3: "3" };
        var modelType = typePool[_this.currentMenu.mold];
        let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
        var params = {
          token: loginUser.token,
          modelId: _this.selectFeedForm.addId,
          modelType: modelType,
          whoId: _this.nodeInfo.userId,
        };

        _this
          .$axios({
            baseURL: apiMap["commonUrl"],
            method: apiMap["addProductForNode"]["method"],
            url: apiMap["addProductForNode"]["url"],
            data: qs.stringify(params, { encode: false }),
          })
          .then(function(response) {
            _this.selectFeedForm.addId = "";
            if (response.data.result.statusCode == 1) {
              _this.waitListVisible = false;
              _this.loadProduct = true;
              _this.$message({
                message: "操作成功！",
                type: "success",
                duration: 1500,
                offset: 230,
              });
              switch (_this.currentMenu.mold) {
                case 0:
                  _this.getDeadArticle(1);
                  break;
                case 1:
                  _this.getDeadAlbum(1);
                  break;
                case 2:
                  _this.getDeadVideo(1);
                  break;
                case 3:
                  _this.getDeadAudio(1);
                  break;
              }
            } else {
              _this.$alert(response.data.result.data, {
                confirmButtonText: "确定",
                showClose: false,
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        _this.$message({
          message: "请选择内容",
          type: "warning",
          duration: 1500,
          offset: 230,
        });
      }
    },
    initLoadProduct(start) {
      this.loadProduct = true;
      switch (this.currentMenu.mold) {
        case 0:
          this.getArticleList(start);
          break;
        case 1:
          this.getAlbumList(start);
          break;
        case 2:
          this.getVideoList(start);
          break;
        case 3:
          this.getAudioList(start);
          break;
      }
    },
    prevtListPageClick(newPage) {
      //即将加载的起始页
      this.initLoadProduct(newPage);
    },
    curtListPageClick(newPage) {
      //即将加载的起始页
      this.initLoadProduct(newPage);
    },
    nextListPageClick(newPage) {
      this.initLoadProduct(newPage);
    },
    getDeadArticle(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["getProduct"]["method"],
          url: apiMap["getProduct"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            modelType: 1,
            whoId: _this.nodeInfo.userId,
          },
        })
        .then(function(response) {
          _this.articleModule.load = false;
          if (response.data.result.statusCode == 1) {
            _this.articleModule.count = response.data.result.count;
            _this.articleModule.list = response.data.result.data;
            _this.$refs.articlePage.internalCurrentPage = page;
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getDeadAlbum(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["getProduct"]["method"],
          url: apiMap["getProduct"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            modelType: 2,
            whoId: _this.nodeInfo.userId,
          },
        })
        .then(function(response) {
          _this.albumModule.load = false;
          if (response.data.result.statusCode == 1) {
            _this.albumModule.count = response.data.result.count;
            _this.albumModule.list = response.data.result.data;
            _this.$refs.albumPage.internalCurrentPage = page;
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getDeadAudio(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["getProduct"]["method"],
          url: apiMap["getProduct"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            modelType: 3,
            whoId: _this.nodeInfo.userId,
          },
        })
        .then(function(response) {
          _this.audioModule.load = false;
          if (response.data.result.statusCode == 1) {
            _this.audioModule.count = response.data.result.count;
            _this.audioModule.list = response.data.result.data;
            _this.$refs.audioPage.internalCurrentPage = page;
          } else {
            if (response.data.result.count == 0) {
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getDeadVideo(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["getProduct"]["method"],
          url: apiMap["getProduct"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            modelType: 4,
            whoId: _this.nodeInfo.userId,
          },
        })
        .then(function(response) {
          _this.videoModule.load = false;
          if (response.data.result.statusCode == 1) {
            _this.videoModule.count = response.data.result.count;
            _this.videoModule.list = response.data.result.data;
            _this.$refs.videoPage.internalCurrentPage = page;
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    prevtArticlePageClick(newPage) {
      this.getDeadArticle(newPage);
    },
    curtArticlePageClick(newPage) {
      this.getDeadArticle(newPage);
    },
    nextArticlePageClick(newPage) {
      this.getDeadArticle(newPage);
    },
    viewArticle(id) {
      this.articleModule.currentId = id;
      this.articleModule.showList = false;
    },
    showArticleList() {
      this.articleModule.showList = true;
    },
    prevtAlbumPageClick(newPage) {
      this.getDeadAlbum(newPage);
    },
    curtAlbumPageClick(newPage) {
      this.getDeadAlbum(newPage);
    },
    nextAlbumPageClick(newPage) {
      this.getDeadAlbum(newPage);
    },
    viewAlbum(id) {
      this.albumModule.currentId = id;
      this.albumModule.showList = false;
    },
    showAlbumList() {
      this.albumModule.showList = true;
    },
    prevtVideoPageClick(newPage) {
      this.getDeadVideo(newPage);
    },
    curtVideoPageClick(newPage) {
      this.getDeadVideo(newPage);
    },
    nextVideoPageClick(newPage) {
      this.getDeadVideo(newPage);
    },
    viewVideo(id) {
      this.videoModule.currentId = id;
      this.videoModule.showList = false;
    },
    showVideoList() {
      this.videoModule.showList = true;
    },
    prevtAudioPageClick(newPage) {
      this.getDeadAudio(newPage);
    },
    curtAudioPageClick(newPage) {
      this.getDeadAudio(newPage);
    },
    nextAudioPageClick(newPage) {
      this.getDeadAudio(newPage);
    },
    viewAudio(id) {
      this.audioModule.currentId = id;
      this.audioModule.showList = false;
    },
    showAudioList() {
      this.audioModule.showList = true;
    },
    getClanTree() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["fatherTree"]["method"],
          url: apiMap["fatherTree"]["url"],
          params: {
            token: loginUser.token,
            family: 1,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.initClanTree(response.data.result.data, 1);
            setTimeout(() => {
              _this.preUnbindSuccessMsg();
            }, 2500);
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initClanTree(data, generation) {
      let _this = this;
      //没有被发讣告的用户
      if (data["deathFlag"] != 1 && data["status"] == 0) {
        if (!_this.newLiveUser.includes(data.userId)) {
          _this.newLiveUser.push(data.userId);
        }
      }
      let partner = data.partners;
      // 过滤家谱成员配偶 08-17
      // if (_this.beArray(partner)) {
      //   for (let p in partner) {
      //     if (partner[p].hasOwnProperty("status")) {
      //       if (partner[p]["deathFlag"] != 1 && partner[p]["status"] == 0) {
      //         if (!_this.newLiveUser.includes(partner[p].userId)) {
      //           _this.newLiveUser.push(partner[p].userId);
      //         }
      //       }
      //     }
      //   }
      // }
      generation++;
      let Children = data.partnerPublicChildren;
      if (_this.beArray(Children)) {
        for (let i in Children) {
          for (let j in Children[i]) {
            if (Children[i][j].hasOwnProperty("status")) {
              if (
                Children[i][j]["deathFlag"] != 1 &&
                Children[i][j]["status"] == 0
              ) {
                if (!_this.newLiveUser.includes(Children[i][j].userId)) {
                  _this.newLiveUser.push(Children[i][j].userId);
                }
              }
            }
            _this.initClanTree(Children[i][j], generation);
          }
        }
      }
    },
    //发送断连家谱通知
    preUnbindSuccessMsg() {
      if (this.newLiveUser.length > 0) {
        let _this = this;
        let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
        var msgContent = `${loginUser.realName}（操作人）已经成功断开 ${_this.nodeInfo.name} 和他（她）父亲的 关系 ，族谱已经发生了变化，前去查看吧。`;
        var initData = {
          fromId: "admin",
          toArr: _this.newLiveUser,
          msgType: "503",
          msgDesc: "您有一条新消息",
          msgContent: msgContent,
        };
        var requestJson =
          "{\n" +
          '    "SyncOtherMachine": 1, \n' +
          '    "From_Account": "' +
          initData["fromId"] +
          '",\n' +
          '    "To_Account": [\n' +
          '        "' +
          initData["toArr"].join('","') +
          '"\n' +
          "    ],\n" +
          '    "MsgRandom": 19901224,\n' +
          '    "MsgBody": [\n' +
          "        {\n" +
          '            "MsgType": "TIMCustomElem",\n' +
          '             "MsgContent": {\n' +
          '        \t"Data": "' +
          initData["msgType"] +
          '", \n' +
          '        \t"Desc": "' +
          initData["msgDesc"] +
          '", \n' +
          '        \t"Ext": "' +
          initData["msgContent"] +
          '"\n' +
          "   \t }\n" +
          "        }\n" +
          "    ],\n" +
          '    "OfflinePushInfo": {\n' +
          '        "PushFlag": 0,\n' +
          '        "Desc": "' +
          initData["msgDesc"] +
          '",\n' +
          '        "Ext": "' +
          initData["msgContent"] +
          '",\n' +
          '        "AndroidInfo": {\n' +
          '            "Sound": "android.mp3"\n' +
          "        },\n" +
          '        "ApnsInfo": {\n' +
          '            "Sound": "apns.mp3",\n' +
          '            "BadgeMode": 1, \n' +
          '            "Title":"apns title",\n' +
          '            "SubTitle":"apns subtitle", \n' +
          '            "Image":"www.image.com" \n' +
          "        }\n" +
          "    }\n" +
          "}";
        var params = {
          token: loginUser.token,
          data: requestJson,
        };
        _this
          .$axios({
            baseURL: apiMap["commonUrl"],
            method: apiMap["quantitySendMsg"]["method"],
            url: apiMap["quantitySendMsg"]["url"],
            data: qs.stringify(params, { encode: false }),
          })
          .then(function(response) {
            // if (response.data.result.ActionStatus == "OK") {
            //   console.log("断连家谱通知，发送成功！");
            // } else {
            //   console.log("断连家谱通知，发送失败！");
            // }
          });
      }
    },
  },
  watch: {
    viewTime() {
      this.getUserProfile();
    },
  },
};
</script>
<style scoped>
.profile-title-wrap {
  position: relative;
  height: 40px;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 2px;
  z-index: 3;
  justify-content: space-between;
  background-color: #1a70db;
}

.go-back-wrap {
  margin-left: 15px;
  padding: 6px 0;
  color: #fff;
  font-size: 14px;
}

.go-list-wrap {
  display: inline-block;
  margin-left: 15px;
  padding: 6px 0;
  color: #000;
  font-size: 14px;
}

.title-text {
  font-size: 16px;
}

.profile-dropdown-wrap {
  width: 50px;
  text-align: center;
}

.change-avatar-btn {
  display: none;
  position: relative;
  top: -40px;
  line-height: 25px;
  text-align: center;
  cursor: pointer;
  opacity: 0.7;
  color: #fff;
  background-color: #000;
}

.head-image-container:hover .change-avatar-btn {
  display: block;
}

.content-text {
  color: #606266;
  font-size: 16px;
}

.relative-profile-wrap {
  position: relative;
  padding: 25px 0 40px;
  min-height: 60px;
  font-size: 16px;
  line-height: 30px;
  background-color: #fff;
}

.head-image-wrap {
  position: absolute;
  top: 42px;
  right: 142px;
}

.head-image-wrapper {
  position: absolute;
  top: 25px;
  right: 142px;
}

.user-profile-avatar {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.modify-avatar-wrap {
  text-align: center;
}

.profile-form-item {
  position: relative;
  width: 700px;
  font-size: 16px;
}

.name-item {
  width: 546px;
}

.year-text {
  position: absolute;
  top: 0;
  left: 55px;
  font-size: 16px;
  color: #606266;
}

.year-text:empty {
  display: none;
}

.relative-date-container {
  width: 700px;
}

.virtual {
  display: none;
}

.profile-buttom-wrap {
  position: relative;
}

.modify-user-wrap {
  position: absolute;
  top: 0px;
  right: 140px;
  line-height: 20px;
  color: #606266;
}

.product-exhibition-area {
  margin-bottom: 20px;
  background-color: #fff;
}

.add-btn-wrap {
  padding-left: 18px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}

.wait-list-wrap {
  border: 1px solid #dcdfe6;
}

.wait-list-container {
  height: 300px;
  padding: 5px 0 5px 15px;
}

.wait-item {
  line-height: 30px;
}

.select-btn-bar {
  padding: 5px 0;
  text-align: center;
  border-top: 1px solid #dcdfe6;
}

.pagination-wrapper {
  margin-bottom: 5px;
  text-align: center;
}

.product-list-wrap {
  height: 320px;
  padding: 10px 15px 10px 20px;
  box-sizing: border-box;
}

.list-item {
  line-height: 30px;
}

.list-item:hover {
  cursor: pointer;
  color: #ff6600;
}

.without-anything-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 30px;
  color: #808080;
}
</style>
